import { useQuery } from "@tanstack/react-query";
import { getPartners, getCalculatorConfig } from "@/lib/api";

export function usePartners() {
  return useQuery({ queryKey: ["partners"], queryFn: getPartners });
}

export function useCalculatorConfig() {
  return useQuery({ queryKey: ["calc-config"], queryFn: getCalculatorConfig });
}
